import React, { useRef, useEffect, cloneElement, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import TYPE from "../../../../constant/TYPE";
import { setAnsweringQuestionsAction } from "../../../../redux/answeringQuestions/answeringQuestions";
import { setTimeCountAction } from "../../../../redux/answeringQuestions/timeCount";
import { setKeypadAction, clearKeypadAction } from "../../../../redux/answeringQuestions/keypad";
import useLocalStorage from "../../../../hooks/useLocalStorage";
import createTimer from "../../../../utils/createTimer";
import { setQuestionViewAction } from "../../../../redux/answeringQuestions/questionView";
import useScribbleTooltip from "../../../../hooks/answeringQuestions/useScribbleTooltip";
import useAmplitude from "../../../../hooks/useAmplitude";
import { setAnswerEditorAction } from "../../../../redux/answeringQuestions/answerEditor";
import { useConceptCheckPlayer } from "../../../../hooks";
import { useHistory, useParams } from "react-router-dom";
import { MESSAGE, URL } from "../../../../constant";
import { getUserAgent } from "../../../../utils/utilityEtc";
import { errorMessage } from "../../../../redux/errorState";
import { store } from "../../../provider/ReduxProvider";
import http from "../../../../http/http";

const Inputer = ( props ) => {

  const inputTimer = useRef();

  const useInfo = useSelector( state => state.user.info );
  const deviceInfo = useSelector( state => state.deviceInfo );
  const answeringQuestions = useSelector( state => state.answeringQuestions );
  const answerEditor = useSelector( state => state.answerEditor );

  const dispatch = useDispatch();
  const setAnsweringQuestions = payload => { dispatch( setAnsweringQuestionsAction( payload ) ) };
  const setTimeCount = payload => { dispatch( setTimeCountAction( payload ) ) };
  const setKeypad = payload => { dispatch( setKeypadAction( payload ) ) };
  const clearKeypad = () => { dispatch( clearKeypadAction() ) };
  const setQuestionView = payload => { dispatch( setQuestionViewAction( payload ) ) };
  const setAnswerEditor = payload => { dispatch( setAnswerEditorAction( payload ) ) };

  const { setAmplitudeLog } = useAmplitude();
  const { showScribbleTooltip } = useScribbleTooltip();

  const { userData } = useLocalStorage();

  const [, setConceptPopup] = useConceptCheckPlayer();  // 개념확인 팝업
  const params = useParams();
  const history = useHistory();

  useEffect( () => {
    inputTimer.current = createTimer( updateInputTime );
    return () => {
      clearKeypad();
    };
  }, [] );

  const updateInputTime = ( time ) => {
    setTimeCount( { inputTime : time } );
  };

  useEffect( () => {
    if ( TYPE.DEVICE.PAD === deviceInfo.type ) {
      const orientation = window.matchMedia( '( orientation:portrait )' );
      orientation.addEventListener( 'change', changeOrientation );
      changeOrientation( orientation );
      return () => {
        orientation.removeEventListener( 'change', changeOrientation );
      };
    }
  }, [ deviceInfo.type ] );

  const changeOrientation = ( event ) => {
    setKeypad( { orientation : event.matches ? TYPE.ORIENTATION.PORTRAIT : TYPE.ORIENTATION.LANDSCAPE } );
  };

  useEffect( () => {
    if ( answeringQuestions.data.kypdTyCd ) {
      if ( answeringQuestions.keypadType ) {
        if (TYPE.KEYPAD.NOTE !== answeringQuestions.keypadType) {
          setAnsweringQuestions({ 
            keypadType: answeringQuestions.data.objctYn === 'Y' 
              ? TYPE.KEYPAD.MULTIPLE 
              : answeringQuestions.data.kypdTyCd 
          });
        }
        
      } else {
        let keypadType = '';
        
        if (TYPE.DEVICE.PC === deviceInfo.type || userData.isKeypad) {
          keypadType = answeringQuestions.data.kypdTyCd;
        } else {
          keypadType = TYPE.KEYPAD.NOTE;
        }

        if (answeringQuestions.data.objctYn === 'Y') {
          keypadType = TYPE.KEYPAD.MULTIPLE
        }

        setAnsweringQuestions({ keypadType });
      }
    }
  }, [answeringQuestions.data.kypdTyCd, answeringQuestions.data.objctYn ] );

  useEffect( () => {
    if ( answeringQuestions.data.qstCd ) {
      return () => {
        inputTimer.current.clear();
        setTimeCount( { inputTime : 0 } );
      };
    }
  }, [ answeringQuestions.data.qstCd ] );

  const count = () => {
    inputTimer.current.start();
  };

  const selectArea = ( event ) => {
    
    const highlightArea = event.target.closest( '.active-bd' );
    
    if ( highlightArea ) {
      const answerArea = highlightArea.querySelector( `[ id*=${ TYPE.ID.ANSWER_AREA } ]` ) || highlightArea.previousSibling.querySelector( `[ id*=${ TYPE.ID.ANSWER_AREA } ]` );
      setAnsweringQuestions( { answerIndex : parseInt( answerArea.id.slice( TYPE.ID.ANSWER_AREA.length ) ) } );
      ! answerEditor.isShow && setAnswerEditor( { answerKey : '' } );
    } else {
      const name = !answeringQuestions?.learningType ? '진단연습장 시작' : '학습연습장 시작';
      // 연습장 on??
      setAnsweringQuestions( { isShowKeypad : false } );
      setQuestionView( { tooltipStatus : 0 } );
      showScribbleTooltip();
      
      if (answeringQuestions.isShowKeypad) {
        setAmplitudeLog({
          eventName: {
            name,
            event: {
              "학습유형": '',
              "소주제이름": answeringQuestions?.data?.stgNm,
              "소주제코드": answeringQuestions?.data?.stgCd,
              "문항코드": answeringQuestions?.data?.qstCd,
              "커리큘럼그룹": answeringQuestions?.data?.thmaNm,
              "커리큘럼명": answeringQuestions?.data?.stepNm,
            }
          },
          isHackleSend: name === '학습연습장 시작',
        })
      }

    }
  };

  // 개념풀이 버튼 handler
  const conceptBtnHandler = async () => {
    setConceptPopup({ 
      url: answeringQuestions?.cncpMeta,
      title: answeringQuestions?.data?.stgNm, 
      stgCd: answeringQuestions?.data?.stgCd, 
      stepNm: answeringQuestions?.data?.stepNm, 
      thmaNm: answeringQuestions?.data?.thmaNm, 
      onOff: true 
    });
  }

  return cloneElement( props.children || <Fragment />, { onCount : count, onSelect : selectArea, onSelectConceptBtn : conceptBtnHandler } );

};

export default Inputer;
